import React, {useRef,useState,useEffect,useMemo, useContext} from 'react'
import {Link, useLocation} from 'react-router-dom'
import he from 'he'
import '../../../styles/comedyContent.css'
import Skeleton from '../skeleton'
import { Helmet } from 'react-helmet-async'
import ComedyBreadCrumb from '../comedyBreadCrumb'
import UnibotsPlayer from '../../ads/unibotsPlayer'
import { DeviceContext } from '..'
import SocialShare from '../socialShare'


const ComedyPicture = ({data}) => {

            const ssrData = data?.[0]?.contentPage || {}
            const ssrContent = ssrData?.content || {}
            const ssrContentError = ssrData?.contentError
            const ssrPicId = ssrData?.ssrPicId
            const picIdRef= useRef(ssrPicId)
            const loc =useLocation().pathname
             let contentArray=loc.replace('.html',"").split('-')  
            let pic_id =contentArray[contentArray.length-1]
          
         
           
            const [content,setContent] = useState(ssrContent)
            const [prev,setPrev] = useState(ssrData.previous)
            const [nxt,setNxt] = useState(ssrData.next)
            const [contentError,setContentError] = useState(ssrContentError)
            const [loading,setLoading] = useState(false)
            const [hydrating,setHydrating] = useState(true)
            const {mobile,setMobile} = useContext(DeviceContext)
           
            
    
             useEffect(() =>  {
                              const one = setTimeout(() => {
                              setHydrating(false) 
                              }, 500);
            
                              return () => clearTimeout(one)
            
                }, [])


              useEffect(()  =>  {
                                  
                              if (ssrContent &&  picIdRef.current === pic_id)  {
                                picIdRef.current = pic_id
                                setLoading(false)
                                return;

                              }  
              
                               const getData = async() => {
                                  setLoading(true)
                                  setMobile(window.innerWidth > 768 ? false : true)
                             try {
                                    const response = await fetch(
                                        `https://www.teluguone.com/comedy/comedyGallerySingleJson.php?pic_id=${pic_id}`
                                    );

                                    if (!response.ok) {
                                        throw new Error("Network response was not ok");
                                    }

                                    const result = await response.json();

                                    const items = Array.isArray(result?.comedy_gallery_single)
                                        ? result.comedy_gallery_single
                                        : [];

                                    const content = items[1] ?? null;
                                    const navBlock1 = items[2] ?? [];
                                    const navBlock2 = items[3] ?? [];

                                    const previous =
                                        typeof navBlock1.previous_url === "string"
                                        ? navBlock1
                                        : [];

                                    const next =
                                        typeof navBlock1.next_film === "string"
                                        ? navBlock1
                                        : navBlock2 ?? [];

                                    setContent(content);
                                    setPrev(previous);
                                    setNxt(next);
                                    setContentError(null);
                                    setLoading(false);

                                    } catch (error) {
                                    console.error("Error fetching Content content:", error);

                                    setContent(null);
                                    setPrev({});
                                    setNxt({});
                                    setContentError(error.message);
                                    setLoading(false);
                                    }
                        }
                             
                             
              
              
                              getData()
                              
              
                  },[pic_id])

     


             



    return (
      <div className='container-fluid comedy-picture-page g-0'>
            
                 <div className='row g-0'>
                  <Helmet> <title>Chitti | Fun Images | TeluguOne </title></Helmet>

                  <div className='col-12'>
                      <ComedyBreadCrumb breadCrumb={{one:"Chitti-Archive",two:''} } />
                </div>
                <div className='col-12'><UnibotsPlayer /></div>
                   <div className='col-12'>
                  <div className='comedy-content-box comedy-picture-box'>
                     {!mobile &&(loading || hydrating) &&
                     <> 
                  <Skeleton type="title" />
                  <div className='comedy-main-content-box' >
                  <Skeleton type="content-square" />
                  <Skeleton type="paragraph" />
                  <Skeleton type="paragraph" />
                  <Skeleton type="paragraph" />
                  <Skeleton type="paragraph" />
                  <Skeleton type="paragraph" />
                  <Skeleton type="paragraph" />
                  <Skeleton type="paragraph" />
                  <Skeleton type="paragraph" />
                  <Skeleton type="paragraph" /><Skeleton type="paragraph" /><Skeleton type="paragraph" /><Skeleton type="paragraph" /><Skeleton type="paragraph" /><Skeleton type="paragraph" /><Skeleton type="paragraph" /><Skeleton type="paragraph" />
                  <Skeleton type="paragraph" /><Skeleton type="paragraph" /><Skeleton type="paragraph" /><Skeleton type="paragraph" /><Skeleton type="paragraph" /><Skeleton type="paragraph" />
                  <Skeleton type="paragraph" /><Skeleton type="paragraph" /><Skeleton type="paragraph" /><Skeleton type="paragraph" />
                  </div>
                   </> 
                    }
                   


                       {content &&  
                  <>
                <h1 >
                 {content && content.title  ? content.title : ''}</h1>
                 {/* <img src={content.content_img ? content.content_img : '/comedy/assets/images/error_img.webp'} className={`${hydrating ? 'ssr-hidden' : ''}`}  loading="eager" fetchpriority="high" alt="vc-img" /> */}
                 {   <div id="loading-div" className={`${hydrating ? 'ssr-hidden' : ''}`} style={{width:"100%"}}>
                          {content && content.audio_file && content.audio_file !== "https://www.teluguone.com/tone_cms/" &&  <audio controls preload="metadata" style={{ width: "100%" }}>
                                 <source src={content.audio_file} type="audio/mpeg" />
                                       Your browser does not support the audio element.
                           </audio>}

                           {content && content.stimg && <img src={content.stimg} alt="picture perfect" />}
                           {contentError &&   <div className="json-loading-error-div">
                            <img loading="eager" src="/comedy/assets/images/json_error.png" alt="json_error" />
                           </div>
                        }
                        {content &&<div style={{width:"100%"}}> <SocialShare /></div> }
                       </div>}
                      </>   }


                 
                       

                  </div>



                   </div>


                    <div className='col-12'><center> 
                      <a href="https://news.google.com/publications/CAAqBwgKMPfspQswz_e9Aw?hl=en-IN&amp;gl=IN&amp;ceid=IN%3Aen" target="_blank" rel="noreferrer"><img src="https://www.teluguone.com/images/g-news-banner.gif" alt="google-banner" /></a>
                   </center></div>


                    <div className='col-12'>
            <div className='prev-next-box d-flex justify-content-between'>
              {prev && prev.previous_url ? <button type="button"><Link to={prev.previous_url.substring(prev.previous_url.lastIndexOf('/pictures')).replace("?","-")} >{"«"} Previous</Link></button> : <p> </p>}
              { nxt && nxt.next_film ?   <button type="button"><Link to={nxt.next_film.substring(nxt.next_film.lastIndexOf('/pictures')).replace("?","-")} >Next {"»"}</Link></button> : <p> </p>}
         </div>                                             
                     </div>



                 </div>

             
      </div>
    )
  }
  
  export default ComedyPicture;





